import {useCallback} from 'react';
import {getRequiredDisplayFieldKeys} from '@/utils/salesTargetDisplayFieldsConfig';

export const useDisplayContentValidation = (isLinkedTargetType) => {
  const isLanguageContentValid = useCallback(
    (content) => {
      if (!content) return false;
      const validationFields = isLinkedTargetType
        ? ['titleValid', 'descriptionValid', 'title', 'description']
        : [
            'excerptValid',
            'termsValid',
            'titleValid',
            'title',
            'excerpt',
            'terms'
          ];
      return validationFields.some(
        (field) =>
          content[field] === true ||
          content[field] === undefined ||
          content[field] === ''
      );
    },
    [isLinkedTargetType]
  );

  const validateDisplayContent = useCallback(
    (formData) => Object.values(formData).some(isLanguageContentValid),
    [isLanguageContentValid]
  );

  return {isLanguageContentValid, validateDisplayContent};
};

export const useV2DisplayContentValidation = (targetType) => {
  const isLanguageContentValid = useCallback(
    (content) => {
      if (!content) return true;
      const requiredKeys = getRequiredDisplayFieldKeys(targetType, 'v2');
      if (!requiredKeys) return true;
      return requiredKeys.some(
        (key) =>
          content[key] === undefined ||
          content[key] === null ||
          content[key] === '' ||
          content[`${key}Valid`] === true ||
          content[`${key}Valid`] === undefined
      );
    },
    [targetType]
  );

  const validateDisplayContent = useCallback(
    (formData) => Object.values(formData).some(isLanguageContentValid),
    [isLanguageContentValid]
  );

  return {isLanguageContentValid, validateDisplayContent};
};
